<template>
  <div class="col-12">
    <span class="top-actions">
      <button
        class="mycustom-success-button"
        @click="showCreateAppointmentModel"
      >
        Add Appointment
      </button>
      <button
        type="button"
        class="mycustom-success-button"
        @click="dueAppointmentsNavigation"
        :style="
          active_buttton == 'due'
            ? {
                backgroundColor: 'beige',
                border: '1px solid brown',
              }
            : {}
        "
      >
        <i class="bi bi-plus-square-dotted"></i> Due-Today
      </button>
      <button
        type="button"
        class="mycustom-success-button"
        @click="missedAppointmentsNavigation"
        :style="
          active_buttton == 'missed'
            ? {
                backgroundColor: 'beige',
                border: '1px solid brown',
              }
            : {}
        "
      >
        <i class="bi bi-plus-square-dotted"></i> Missed
      </button>

      <button
        :style="
          active_buttton == 'all'
            ? {
                backgroundColor: 'beige',
                border: '1px solid brown',
              }
            : {}
        "
        type="button"
        class="mycustom-success-button"
        @click="allAppointmentsNavigation"
      >
        <i class="bi bi-plus-square-dotted"></i> All
      </button>
    </span>
  </div>
</template>

<script>
export default {
  name: "AppointmentsPages",
  data() {
    return {
      loading: true,
      active_buttton: "all",
    };
  },

  props: {
    appointment_id: {
      type: [Number, String],
      required: true,
    },
  },
  methods: {
    showCreateAppointmentModel() {
      this.$emit("show-create-appointment-model");
    },
    dueAppointmentsNavigation() {
      this.active_buttton = "due";
      const payload = { url: "due_appointments" };
      this.$emit("shift-appointment-content", payload);
    },
    missedAppointmentsNavigation() {
      this.active_buttton = "missed";
      const payload = { url: "missed_appointments" };
      this.$emit("shift-appointment-content", payload);
    },
    allAppointmentsNavigation() {
      this.active_buttton = "all";
      const payload = { url: "get_all_appointments" };
      this.$emit("shift-appointment-content", payload);
    },
  },
  mounted() {
    // // this.api_call();
    // console.log(this.activeUrl);
    // console.log("hjj");
  },
};
</script>

<style scoped></style>
